export const checkVisibilityRule = (
  rule: string,
  rules?: { [key: string]: boolean }
) => {
  if (!rules || !(rule in rules)) {
    return true;
  }
  return rules[rule];
};
